import { useContext } from "react";

import { BrazeOperatorContext } from "@lib/BrazeOperatorContext";

/**
 * Hook to check if Operator should be able to make changes to components agentically.
 *
 * Returns true if the component is rendered within a BrazeOperatorProvider
 * with `enabled={true}`, or within a BrazeOperatorProviderWithFeatureFlipper
 * where the feature flipper is enabled.
 *
 * This hook is useful for components that need to conditionally render
 * operator-enabled functionality based on their position in the component tree.
 *
 * @example
 * const MyComponent = () => {
 *   const isAgenticChangeEnabled = useOperatorAgenticChangeEnabled();
 *
 *   if (isAgenticChangeEnabled) {
 *     return <OperatorEnabledVersion />;
 *   }
 *
 *   return <StandardVersion />;
 * };
 */
export const useOperatorAgenticChangeEnabled = () => {
  const context = useContext(BrazeOperatorContext);
  return context.isAgenticChangeEnabled;
};
